import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";

export const saveRtFeedFeedingPlanForPatient = async (postObj) => {
  return await apiClient.post(`/diticianModule/saveRTFeeds`, postObj, {
    headers: authHeader(),
  });
};

export const getPatientRTFeedPlanByAddmissionId = async (postObj) => {
  return await apiClient.post(`/diticianModule/getRTFeeds`, postObj, {
    headers: authHeader(),
  });
};
export const updatePatientRTFeedStatus = async (postObj) => {
  return await apiClient.post(`/diticianModule/markRTFeeds`, postObj, {
    headers: authHeader(),
  });
};
